import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-splitbutton',
  templateUrl: './splitbutton.component.html',
  styleUrl: './splitbutton.component.scss',
  standalone: false
})
export class SplitbuttonComponent {
  @Input() label: string;
  @Input() icon: string;
  @Input() styleClass: string;
  @Input() disabled: boolean;

  @Output() press: EventEmitter<MouseEvent> = new EventEmitter();
}
